import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NewsService } from '../service/news.service';
import * as NewsActions from './news.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class NewsEffects {
  private actions$ = inject(Actions);
  private newsService = inject(NewsService);

  getNews$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NewsActions.loadNews),
      switchMap(({ language }) => {
        return this.newsService.getNews(language).pipe(
          map((news) => NewsActions.loadNewsSuccess({ news })),
          catchError((error) => of(NewsActions.loadNewsFailure({ error }))),
        );
      }),
    ),
  );

  setNewsSeenFlag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NewsActions.setNewsSeenFlag),
      switchMap(({ newsType }) =>
        this.newsService.setNewsSeenFlag(newsType).pipe(
          map((response) => NewsActions.setNewsSeenFlagSuccess({ response })),
          catchError((error) => of(NewsActions.setNewsSeenFlagFailure({ error }))),
        ),
      ),
    ),
  );

  setNewsContentSeen$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NewsActions.setNewsContentSeen),
      switchMap(({ id }) =>
        this.newsService.setNewsContentSeen(id).pipe(
          map((response) => NewsActions.setNewsContentSeenSuccess({ response })),
          catchError((error) => of(NewsActions.setNewsContentSeenFailure({ error }))),
        ),
      ),
    ),
  );
}
